<div id="digital-assets-order-container" [ngClass]="{isTruv: provider === 'Truv'}"></div>
